module.exports = __webpack_public_path__ + "media/images/prizes__prizeFg--3-20e6ede9ecefae798ec006c31a63200e.png";